"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _theme = _interopRequireDefault(require("../../../theme"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var Up = function Up() {
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("path", {
    fill: _theme["default"].scaleLevel20,
    d: "M16.262 39.817c-2.376-.343-4.84-1.556-7.328-3-2.143-1.242-4.18-2.84-5.844-5.341-1.9-2.854-2.565-5.789-2.898-8.484-.598-4.848.378-8.627.508-9.03.857-2.644 2.13-5.075 3.915-7.125 1.778-2.04 3.877-3.808 6.288-4.99C13.266.69 15.885.094 18.585.016c2.828-.082 5.461.13 7.636 1.097 2.564 1.14 4.539 3.14 6.211 4.826 2.757 2.78 4.109 5.756 4.505 6.481.161.296 2.017 3.557 2.653 7.883.38 2.591.781 5.633-.222 8.456-1.217 3.42-3.815 5.782-6.3 7.423-3.82 2.524-8.072 2.95-8.933 3.114-.442.084-3.76 1.114-7.873.52Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: _theme["default"].scaleLevel100,
    d: "m26.74 19.38-6.12-6.12c-.08-.08-.18-.14-.28-.19a.865.865 0 0 0-.95.19l-6.12 6.12c-.34.34-.34.9 0 1.24.34.34.9.34 1.24 0l4.63-4.63v10.14c0 .48.39.88.88.88s.88-.39.88-.88V15.99l4.63 4.63c.34.34.9.34 1.24 0 .34-.34.34-.9 0-1.24h-.03Z"
  }));
};
var _default = exports["default"] = Up;